import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  // Load translation files
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'fr',
    
    // Supported languages
    supportedLngs: ['fr', 'en'],
    
    // Debug mode (disable in production)
    debug: false,
    
    // Namespace
    ns: ['translation'],
    defaultNS: 'translation',
    
    // Backend options for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Detection options
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache user language selection
      caches: ['localStorage'],
      
      // LocalStorage key
      lookupLocalStorage: 'i18nextLng',
    },
    
    // React options
    react: {
      useSuspense: true,
    },
    
    // Interpolation options
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },
  });

export default i18n;
